<template>
  <div>
    <el-table :data="tabledata" style="width: 100%" v-loading="loading">
      <el-table-column prop="name" label="试卷名称" width="180">
      </el-table-column>
      <el-table-column prop="teacher" label="老师" width="180">
      </el-table-column>
      <el-table-column prop="start" label="开始时间" :formatter="formatters">
      </el-table-column>
      <el-table-column prop="end" label="结束时间" :formatter="formatters1">
      </el-table-column>
      <el-table-column prop="times" label="时长">
      </el-table-column>
      <!-- <el-table-column prop="times" label="时长">
      </el-table-column> -->
      <el-table-column label="操作" width="100">
        <template slot-scope="scope">
          <template v-if="!scope.row.is_test">
            <el-button @click="handleClick(scope.row)" type="primary" size="mini" v-if="!scope.row.is_test1">开始考试</el-button>
            <el-button  type="info" size="mini" v-else>未考试</el-button>
          </template>
          <el-button @click="handleClick(scope.row)" type="success" size="mini" v-else>查看成绩</el-button>
        </template>
      </el-table-column>
    </el-table>
    <div style="height:20px;"></div>
     <pagelist @currentchange="pagehandle"  :page-count="pageform.pages" :current-page="pageform.pageNum"  :total="pageform.total" :page-size="pageform.pageSize"></pagelist>
  </div>
</template>

<script>
import pagelist from './pagelist'
export default {
    components: {
    pagelist
  },
  props: {

  },
  data() {
    return {
      tabledata: [],
      loading: true,
      timer: '',
       pageform: {
              total: 0,
              pages: 5,  // 总页数
              pageNum: 1, // 当前的页码
              pageSize: 20, // 每页显示条目个数
            },
       params: {  
        per_page: 20,
        page: 1,
      },
    };
  },
  computed: {

  },
  created() {
    this.gettheorytestlist()

    var that = this;
    var timer1 = setInterval(function () {
      var running = 0;
      that.tabledata.forEach(function (n) {
        var nowdate = new Date().getTime()
        var enddate = new Date(n.end).getTime();
        //   var startdate = new Date(item.start).getTime()
        //   var flags = (nowdate > enddate) || (startdate > nowdate)
        if (!n.is_test) {
          if (nowdate > enddate) {
            n.is_test1 = true;
          }
        }
        running = 1;

      });
      if (running) {
        that.tabledata = that.tabledata;
        that.$forceUpdate()
      }
    }, 1000);
    this.timer = timer1;

  },
  methods: {
       pagehandle(val) {
        this.pageform.pageNum = val;
        this.params.page = val;
        this.gettasklist();
      },
    handleClick(item) {
        this.$router.push({ name: 'theoryexam', query: { testid: item.id } })
        return;
      var nowdate = new Date().getTime()
      var enddate = new Date(item.end).getTime();
      var startdate = new Date(item.start).getTime()
      var flags = (nowdate > enddate) || (startdate > nowdate)
      if (flags) {
        this.$message({
          message: '不在考试时间范围內！',
          type: 'warning'
        });

      } else {
        this.$router.push({ name: 'theoryexam', query: { testid: item.id } })
      }
    },
    handleClick1(item) {
      this.$router.push({ name: 'answerlist', query: { testid: item.id } })
    },
    //全部列表
    gettheorytestlist() {
      this.$http.theorytestlist(this.params)
        .then(res => {
          if (res.code != 0) {
            this.loading = false;
            this.tabledata = res.data;
            //   this.pageform.pages = res.data.allPage;
            //   this.pageform.total = res.data.allCount;
            //   for (var i = 0; i < tabledata.length; i++) {
            //     tabledata[i].textarea = ""
            //     tabledata[i].status = false
            //     tabledata[i].isstore = false
            //     tabledata[i].created_at1=''
            //     this.gettaskstatus(tabledata[i])
            //   }
            //   this.tabledata = tabledata
 this.pageform.pages = res.meta.last_page;
            this.pageform.total = res.meta.total;
          } else {
            this.$message.error(res.message)
          }

        })
    },
    formatters(row, column, cellValue, index) {
      return row.start = this.format(row.start, 'yyyy-MM-dd hh:mm')

      //ele.CreatTime =ele.CreatTime.replace(/\//g, '-');;
      // ele.ActOfflineTime= that.$format(ele.ActOfflineTime,'yyyy-MM-dd hh:mm');
    },
    formatters1(row, column, cellValue, index) {
      return row.end = this.format(row.end, 'yyyy-MM-dd hh:mm')

      //ele.CreatTime =ele.CreatTime.replace(/\//g, '-');;
      // ele.ActOfflineTime= that.$format(ele.ActOfflineTime,'yyyy-MM-dd hh:mm');
    }
  },
  destroyed() {
    clearInterval(this.timer)
  }
};
</script>

<style  lang="less">
</style>



// WEBPACK FOOTER //
// src/components/assessment/theorylist.vue